import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TOKEN } from '../constants/storage';
import { LocalStorageService } from '../services/storage.service';

@Injectable({
    providedIn: 'root',
})
export class PublicViewGuard implements CanActivate {

    private readonly localStorageService = inject(LocalStorageService);

    constructor(private router: Router) {}

    canActivate() {
        const token = this.localStorageService.getItem(TOKEN);

        if (token !== null) {
            this.router.navigate(['/']);
            return false;
        } else {
            return true;
        }
    }
}
